import { makeActionCreator } from '../../../utilities'
import { SearchConstants } from './search.constants'

export const setSearchText = makeActionCreator(SearchConstants.SET_SEARCH_TEXT, 'searchText')
export const initializeSearch = makeActionCreator(SearchConstants.INITIALIZE_SEARCH, 'options')
export const setFilteredOptions = makeActionCreator(SearchConstants.SET_FILTERED_OPTIONS, 'filteredOptions')
export const setIsLoading = makeActionCreator(SearchConstants.SET_IS_LOADING, 'isLoading')
export const setCurrentOptions = makeActionCreator(SearchConstants.CURRENT_OPTIONS, 'currentOptions')
export const resetSearchState = makeActionCreator(SearchConstants.RESET_STATE)
